import { Component, inject } from '@angular/core';
import { OrgWizardStateService } from '../services/org-wizard-state.service';

/**
 * Step 2 — Basics: organization name, description, and a curated subset of
 * {@link OrganizationSettings} defaults.
 *
 * P1 collects only name and description. Full settings (working hours,
 * dayOfMonth*, etc.) ship with sensible defaults from the backend and can be
 * edited via the existing org settings page after creation.
 */
@Component({
    selector: 'newgenus-org-creation-step-basics',
    templateUrl: './step-2-basics.component.html',
    styleUrls: ['./step-2-basics.component.scss'],
    standalone: false,
})
export class StepBasicsComponent {
    public state = inject(OrgWizardStateService);

    public updateName(value: string): void {
        this.state.dispatch({
            basics: {
                name: value,
                description: this.state.snapshot?.basics.description ?? '',
                settings: this.state.snapshot?.basics.settings ?? {},
            },
        });
    }

    public updateDescription(value: string): void {
        this.state.dispatch({
            basics: {
                name: this.state.snapshot?.basics.name ?? '',
                description: value,
                settings: this.state.snapshot?.basics.settings ?? {},
            },
        });
    }
}
